import React  from "react";
import { useParams } from 'react-router-dom';
import FinalPayForm from "./components/FinalPayForm";
import FinalPayComputation from "./components/FinalPayComputation";
import FinalPayDtr from "./components/FinalPayDtr";
import FinalPayAnnex from "./components/FinalPayAnnex";

const ViewFinalPay = () => {
	const { payId } = useParams();

	return (
	    <div className="max-w-[1242px]">
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
				
				<FinalPayForm recordId={payId} mode="view"/>

				<FinalPayDtr />

				<FinalPayComputation/>

				<FinalPayAnnex/>

	      </div>
	    </div>
    );
};

export default ViewFinalPay;